import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AtuacaoPage from "../pages/atuacao/page";
import CriminalPage from "../pages/atuacao/criminal/page";
import PenalEmpresarialPage from "../pages/atuacao/penal-empresarial/page";
import CivilPage from "../pages/atuacao/civil/page";
import SobrePage from "../pages/sobre/page";
import DiferencialPage from "../pages/atendimento/page";
import BlogPage from "../pages/blog/page";
import BlogPostPage from "../pages/blog/PostPage";
import AdminLoginPage from "../pages/admin/login/page";
import AdminPage from "../pages/admin/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/atuacao", element: <AtuacaoPage /> },
  { path: "/atuacao/criminal", element: <CriminalPage /> },
  { path: "/atuacao/penal-empresarial", element: <PenalEmpresarialPage /> },
  { path: "/atuacao/civil", element: <CivilPage /> },
  { path: "/sobre", element: <SobrePage /> },
  { path: "/diferencial", element: <DiferencialPage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/blog/:slug", element: <BlogPostPage /> },
  { path: "/admin/login", element: <AdminLoginPage /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
